import 'babel-polyfill/dist/polyfill';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();